module.exports = __webpack_public_path__ + "img/advantage4Blue.82a884ff.png";